<p class="h3 p-tb-12 border-bottom m-b-0 m-t-20">{{ 'accountSelection.cancelConfirmation' | cxTranslate }}</p>

<p class="text-danger ff-bold m-t-6">{{ 'accountSelection.notSelectedWarnig' | cxTranslate }}</p>
<div class="actions m-t-20">
  <button type="button" class="btn btn-outline-primary m-t-20" (click)="cancel()">{{ 'accountSelection.cancel' | cxTranslate }}</button>

  <button type="button" class="btn btn-primary m-t-20" (click)="confirm()">{{ 'accountSelection.confirm' | cxTranslate }}</button>
</div>
